import type { NavRoute } from '@connected/ui/components/submenu-navigation';

import { SubmenuNavigation } from '@connected/ui/components/submenu-navigation';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { z } from 'zod';

export const Route = createFileRoute(
    '/(auth)/admin/(organisations)/organisation',
)({
    component: RouteComponent,
    validateSearch: z.object({
        organisationId: z.string().min(1),
    }),
});

function RouteComponent() {
    const search = Route.useSearch();

    const items: NavRoute[] = [
        {
            label: 'Organisatie',
            to: '/admin/organisation/information',
            search,
        },
        {
            label: 'Templates',
            to: '/admin/organisation/templates',
            search,
        },

    ];

    return (
        <div>
            <SubmenuNavigation items={items} />
            <Outlet />
        </div>
    );
}
